(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eluna-apparel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('eluna-apparel'))customElements.define('eluna-apparel',class extends HTMLElement{
connectedCallback(){
 if(this.ready||this.dataset.directory==='true')return;this.ready=true;this.abort=new AbortController();const on=(el,type,fn)=>el.addEventListener(type,fn,{signal:this.abort.signal});
 this.slides=[...this.querySelectorAll('[data-slide]')];this.tabs=[...this.querySelectorAll('[data-select]')];this.index=0;this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.dataset.autoplay!=='true'||this.reduced.matches;this.visible=false;this.hover=false;
 this.pause=this.querySelector('[data-pause]');this.stage=this.querySelector('.eap-stage');
 this.tabs.forEach((tab,i)=>on(tab,'click',e=>{e.preventDefault();this.stop();this.show(i,true)}));
 on(this.querySelector('[data-prev]'),'click',()=>{this.stop();this.show(this.index-1,true)});on(this.querySelector('[data-next]'),'click',()=>{this.stop();this.show(this.index+1,true)});
 on(this.pause,'click',()=>{this.paused=!this.paused;this.sync()});
 on(this,'pointerenter',e=>{if(e.pointerType==='mouse'){this.hover=true;this.sync()}});on(this,'pointerleave',()=>{this.hover=false;this.sync()});
 on(this,'focusin',()=>this.stop());on(document,'visibilitychange',()=>this.sync());on(this.reduced,'change',()=>{if(this.reduced.matches)this.stop()});
 on(this.stage,'keydown',e=>{if(!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();this.stop();this.show(this.index+(e.key==='ArrowRight'?1:-1),true)});
 on(this.stage,'touchstart',e=>{this.touch={x:e.touches[0].clientX,y:e.touches[0].clientY}},{passive:true});
 on(this.stage,'touchend',e=>{if(!this.touch)return;const dx=e.changedTouches[0].clientX-this.touch.x,dy=e.changedTouches[0].clientY-this.touch.y;this.touch=null;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.4){this.stop();this.show(this.index+(dx<0?1:-1),true)}});
 this.slides.forEach(slide=>{const visual=slide.querySelector('.eap-visual'),button=slide.querySelector('.eap-flip');if(visual.querySelector('.eap-back')){button.hidden=false;on(button,'click',()=>{this.stop();const back=visual.classList.toggle('is-back');button.setAttribute('aria-pressed',String(back));button.textContent=back?this.dataset.frontLabel:this.dataset.backLabel})}});
 this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync()},{threshold:.3});this.observer.observe(this.stage);this.sync();
}
stop(){this.paused=true;this.sync()}
sync(){clearInterval(this.timer);this.pause.setAttribute('aria-pressed',String(this.paused));this.pause.textContent=this.paused?'▶':'Ⅱ';this.pause.setAttribute('aria-label',this.paused?this.dataset.playLabel:this.dataset.pauseLabel);if(!this.paused&&this.visible&&!this.hover&&!document.hidden)this.timer=setInterval(()=>this.show(this.index+1,false),8000)}
show(index,announce){this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>slide.hidden=i!==this.index);this.tabs.forEach((tab,i)=>tab.setAttribute('aria-current',String(i===this.index)));this.querySelector('[data-counter]').textContent=String(this.index+1).padStart(2,'0')+' / 04';if(announce)this.querySelector('.eap-status').textContent=this.slides[this.index].getAttribute('aria-label')}
disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.abort?.abort();this.ready=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eluna-city-signatures"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('eluna-city-signatures')){customElements.define('eluna-city-signatures',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;this.panels=[...this.querySelectorAll('.ecs-panel')];this.buttons=[...this.querySelectorAll('[data-city]')];this.index=0;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.dataset.autoplay!=='true'||this.motion.matches;this.visible=false;this.hovered=false;this.focused=false;this.querySelector('.ecs-controls').hidden=false;this.dataset.ready='';this.show(0);this.buttons.forEach((button,index)=>button.addEventListener('click',()=>{this.paused=true;this.show(index);this.sync();},{signal}));this.querySelector('[data-prev]').addEventListener('click',()=>{this.paused=true;this.show(this.index-1);this.sync();},{signal});this.querySelector('[data-next]').addEventListener('click',()=>{this.paused=true;this.show(this.index+1);this.sync();},{signal});this.querySelector('[data-toggle]').addEventListener('click',()=>{this.paused=!this.paused;this.sync();},{signal});this.addEventListener('mouseenter',()=>{this.hovered=true;this.sync();},{signal});this.addEventListener('mouseleave',()=>{this.hovered=false;this.sync();},{signal});this.addEventListener('focusin',()=>{this.focused=true;this.sync();},{signal});this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget)){this.focused=false;this.sync();}},{signal});document.addEventListener('visibilitychange',()=>this.sync(),{signal});this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.sync();},{signal});document.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('.ecs-panel');if(panel&&this.contains(panel)){this.paused=true;this.show(this.panels.indexOf(panel));this.sync();}},{signal});this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.15});this.observer.observe(this);this.sync();}
show(index){this.index=(index+this.panels.length)%this.panels.length;this.panels.forEach((panel,i)=>{panel.classList.toggle('is-active',i===this.index);panel.inert=i!==this.index;panel.setAttribute('aria-hidden',String(i!==this.index));this.buttons[i].setAttribute('aria-pressed',String(i===this.index));});}
sync(){clearInterval(this.timer);const control=this.querySelector('[data-toggle]');control.setAttribute('aria-label',this.paused?this.dataset.play:this.dataset.pause);this.querySelector('[data-pause-icon]').hidden=this.paused;this.querySelector('[data-play-icon]').hidden=!this.paused;if(!this.paused&&this.visible&&!this.hovered&&!this.focused&&!document.hidden&&!window.Shopify?.designMode)this.timer=setInterval(()=>this.show(this.index+1),Number(this.dataset.speed)*1000);}
disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.abort?.abort();this.abort=null;}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eluna-hat-guide"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('eluna-hat-guide')){customElements.define('eluna-hat-guide',class extends HTMLElement{
 connectedCallback(){
  if(this._abort)return;this._abort=new AbortController();const opts={signal:this._abort.signal};this.panels=[...this.querySelectorAll('[data-panel]')];this.picks=[...this.querySelectorAll('[data-pick]')];if(!this.panels.length)return;this.index=0;this.visible=false;this.hover=false;this.reduce=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.dataset.autoplay!=='true'||this.reduce.matches;this.play=this.querySelector('[data-play]');this.count=this.querySelector('[data-count]');this.rail=this.querySelector('.ehg__rail');this.stage=this.querySelector('.ehg__stage');this.refresh();
  this.picks.forEach((p,i)=>{p.addEventListener('click',()=>{this.stop();this.show(i);},opts);p.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%this.picks.length;else if(e.key==='ArrowLeft')n=(i-1+this.picks.length)%this.picks.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=this.picks.length-1;else return;e.preventDefault();this.stop();this.show(n);this.picks[n].focus();},opts);});
  this.querySelector('[data-prev]').addEventListener('click',()=>{this.stop();this.show(this.index-1);},opts);this.querySelector('[data-next]').addEventListener('click',()=>{this.stop();this.show(this.index+1);},opts);this.play.addEventListener('click',()=>{this.paused=!this.paused;this.refresh();this.resetTimer();},opts);
  this.addEventListener('focusin',e=>{if(e.target!==this.play)this.stop();},opts);this.addEventListener('pointerenter',e=>{this.hover=e.pointerType==='mouse';},opts);this.addEventListener('pointerleave',()=>{this.hover=false;this.resetTimer();},opts);this.querySelectorAll('details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)this.stop();},opts));
  this.stage.addEventListener('touchstart',e=>{this.touchStart={x:e.touches[0].clientX,y:e.touches[0].clientY};},{...opts,passive:true});this.stage.addEventListener('touchend',e=>{if(!this.touchStart)return;const dx=e.changedTouches[0].clientX-this.touchStart.x,dy=e.changedTouches[0].clientY-this.touchStart.y;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.5){this.stop();this.show(this.index+(dx<0?1:-1));}this.touchStart=null;},{...opts,passive:true});
  this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible)this.resetTimer();},{threshold:.15});this.observer.observe(this.stage);this.reduce.addEventListener('change',()=>{if(this.reduce.matches)this.stop();},opts);this.addEventListener('shopify:block:select',e=>{const i=this.panels.findIndex(p=>p.dataset.blockId===e.detail.blockId);if(i>=0){this.stop();this.show(i);}},opts);this.resetTimer();
 }
 stop(){this.paused=true;this.refresh();}
 refresh(){this.play.textContent=this.paused?'Play':'Pause';this.play.setAttribute('aria-label',(this.paused?'Play':'Pause')+' hat style slideshow');this.stage.setAttribute('aria-live',this.paused?'polite':'off');}
 show(n){this.index=(n+this.panels.length)%this.panels.length;this.panels.forEach((p,i)=>{p.hidden=i!==this.index;p.classList.toggle('is-entering',i===this.index);});this.picks.forEach((p,i)=>p.setAttribute('aria-pressed',String(i===this.index)));this.count.textContent=String(this.index+1).padStart(2,'0')+' / '+this.panels.length;const p=this.picks[this.index];const left=p.offsetLeft-this.rail.offsetLeft;if(left<this.rail.scrollLeft||left+p.offsetWidth>this.rail.scrollLeft+this.rail.clientWidth)this.rail.scrollTo({left:left-this.rail.clientWidth/2+p.offsetWidth/2,behavior:this.reduce.matches?'instant':'smooth'});this.resetTimer();}
 resetTimer(){clearInterval(this.timer);this.timer=setInterval(()=>{if(!this.paused&&this.visible&&!this.hover&&!document.hidden&&!this.panels[this.index].querySelector('details[open]'))this.show(this.index+1);},Number(this.dataset.interval)||8000);}
 disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this._abort?.abort();this._abort=null;}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eluna-highlights"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('eluna-highlights'))customElements.define('eluna-highlights',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.abort=new AbortController();const on=(el,type,fn)=>el.addEventListener(type,fn,{signal:this.abort.signal});this.panels=[...this.querySelectorAll('.elf-panel')];this.tabs=[...this.querySelectorAll('[data-tab]')];this.index=0;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.motion.matches;this.visible=false;this.hover=false;this.toggle=this.querySelector('[data-toggle]');this.stage=this.querySelector('.elf-stage');this.tabs.forEach((tab,i)=>on(tab,'click',()=>{this.stop();this.show(i,true)}));on(this.querySelector('[data-prev]'),'click',()=>{this.stop();this.show(this.index-1,true)});on(this.querySelector('[data-next]'),'click',()=>{this.stop();this.show(this.index+1,true)});on(this.toggle,'click',()=>{this.paused=!this.paused;this.sync()});on(this,'focusin',()=>this.stop());on(this,'pointerenter',e=>{if(e.pointerType==='mouse'){this.hover=true;this.sync()}});on(this,'pointerleave',()=>{this.hover=false;this.sync()});on(document,'visibilitychange',()=>this.sync());on(this.motion,'change',()=>{if(this.motion.matches)this.stop()});on(this.stage,'keydown',e=>{if(!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();this.stop();this.show(this.index+(e.key==='ArrowRight'?1:-1),true)});on(this.stage,'touchstart',e=>{this.touch={x:e.touches[0].clientX,y:e.touches[0].clientY}});on(this.stage,'touchend',e=>{if(!this.touch)return;const dx=e.changedTouches[0].clientX-this.touch.x,dy=e.changedTouches[0].clientY-this.touch.y;this.touch=null;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.4){this.stop();this.show(this.index+(dx<0?1:-1),true)}});this.observer=new IntersectionObserver(e=>{this.visible=e[0].isIntersecting;this.sync()},{threshold:.3});this.observer.observe(this.stage);this.sync()}
stop(){this.paused=true;this.sync()}
sync(){clearInterval(this.timer);this.toggle.textContent=this.paused?'▶':'Ⅱ';this.toggle.setAttribute('aria-label',this.paused?this.dataset.play:this.dataset.pause);this.toggle.setAttribute('aria-pressed',String(this.paused));this.classList.toggle('is-paused',this.paused||!this.visible||this.hover||document.hidden);if(!this.paused&&this.visible&&!this.hover&&!document.hidden)this.timer=setInterval(()=>this.show(this.index+1,false),8000)}
show(i,announce){this.index=(i+this.panels.length)%this.panels.length;this.panels.forEach((p,j)=>p.hidden=j!==this.index);this.tabs.forEach((b,j)=>b.setAttribute('aria-pressed',String(j===this.index)));this.querySelector('[data-count]').textContent=String(this.index+1).padStart(2,'0')+' / 04';if(announce)this.querySelector('[data-status]').textContent=this.panels[this.index].getAttribute('aria-label')}
disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();clearInterval(this.timer);this.ready=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eluna-signature-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eluna-signature-hero')) {
    class ELunaSignatureHero extends HTMLElement {
      connectedCallback() {
        this.slideshow = this.querySelector('slideshow-component');
        this.slider = this.querySelector('[id^="Slider-"]');
        this.slides = Array.from(this.querySelectorAll('[id^="Slide-"]'));
        this.activeIndex = 0;
        this.resizeTimer = null;
        this.isResizing = false;
        this.controlButtons = Array.from(this.querySelectorAll('.slider-button[name]'));

        if (!this.slideshow || !this.slider || this.slides.length < 2) return;

        this.handleSlideChange = this.handleSlideChange.bind(this);
        this.handleControlClick = this.handleControlClick.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.slideshow.addEventListener('slideChanged', this.handleSlideChange);
        this.controlButtons.forEach((button) => button.addEventListener('click', this.handleControlClick));
        window.addEventListener('resize', this.handleResize, { passive: true });
      }

      disconnectedCallback() {
        if (!this.slideshow) return;
        this.slideshow.removeEventListener('slideChanged', this.handleSlideChange);
        this.controlButtons.forEach((button) => button.removeEventListener('click', this.handleControlClick));
        window.removeEventListener('resize', this.handleResize);
        clearTimeout(this.resizeTimer);
      }

      handleSlideChange(event) {
        if (this.isResizing || !event.detail || !event.detail.currentElement) return;
        const nextIndex = this.slides.indexOf(event.detail.currentElement);
        if (nextIndex >= 0) this.activeIndex = nextIndex;
      }

      handleControlClick(event) {
        const increment = event.currentTarget.name === 'next' ? 1 : -1;
        this.activeIndex = (this.activeIndex + increment + this.slides.length) % this.slides.length;
      }

      handleResize() {
        this.isResizing = true;
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          const activeSlide = this.slides[this.activeIndex];
          if (!activeSlide) return;

          this.slider.scrollTo({ left: activeSlide.offsetLeft, behavior: 'auto' });
          this.slideshow.currentPage = this.activeIndex + 1;
          this.slideshow.setSlideVisibility();

          const currentCounter = this.querySelector('.slider-counter--current');
          if (currentCounter) currentCounter.textContent = this.activeIndex + 1;
          this.isResizing = false;
        }, 150);
      }
    }

    customElements.define('eluna-signature-hero', ELunaSignatureHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
